<template>
  <div>
    <b-modal ref="HistoryModal"
             ok-only
             :ok-title="cancelBtnLabel"
             ok-variant="secondary"
             :title="modalTitle"
             :header-bg-variant="headerBgVariant"
             :header-text-variant="headerTextVariant"
             :no-close-on-backdrop="true"
    >
      <ag-grid-vue class="ag-theme-balham grid"
                   :columnDefs="historyColumnsHeaders"
                   :gridOptions="gridOptions"
                   :rowData="listData"
      >
      </ag-grid-vue>
    </b-modal>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue'
  import { setNotifyData } from '@/helpers/commonHelpers';

  export default {
    components: {
      'ag-grid-vue': AgGridVue
    },
    data() {
      return {
        settings: {
          modalTitle: '',
          url: ''
        },
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        historyColumnsHeaders: [
          {
            headerName: 'Change type',
            field: 'history_type',
            cellRenderer: 'agGroupCellRenderer'
          },
          {
            headerName: 'Date & Time',
            field: 'modified',
          },
          {
            headerName: 'User',
            field: 'modified_by'
          }
        ],
        listData: [],
        gridOptions: {
          animateRows: true,
          masterDetail: true,
          defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
          },
          detailCellRendererParams: {
            detailGridOptions: {
              columnDefs: [
                {
                  headerName: 'Field name',
                  field: 'field_name'
                },
                {
                  headerName: 'Previous value',
                  field: 'previous_value_str'
                },
                {
                  headerName: 'Current value',
                  field: 'current_value_str'
                }
              ],
              onGridReady(params) {
                params.api.sizeColumnsToFit();
              }
            },
            getDetailRowData: function (params) {
              params.successCallback(params.data['children']);
            }
          },
        }
      }
    },
    methods: {
      openModal() {
        this.$http.get(`generic/history_by_model/${this.settings.url}`)
          .then((response) => {
              this.listData = [...response.body];
              this.$refs['HistoryModal'].show();
            }
          ).catch((error) => {
          console.log(error);
          this.$notify(setNotifyData('Error', 'Unable to open history', 'error'));
        })
      }
    },
    computed: {
      modalTitle() {
        return `${this.$i18n.t('modal_dialogs.history.changelog')} ${this.settings.title}`;
      },
      cancelBtnLabel() {
        return `${this.$i18n.t('buttons.common.exit')}`;
      }
    },
    mounted() {
      this.$root.$on('openHistoryModal', (settings) => {
        if (this.$refs['HistoryModal']) {
          this.settings = settings;
          this.openModal();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openHistoryModal');
    }
  }
</script>

<style scoped>
  .grid {
    height: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/HistoryModal.vue